export const senecPaperTheme = {
    styleOverrides: {
        elevation1: {
            boxShadow: "0px 12px 24px 0px rgba(43, 43, 43, 0.08)",
        },
        elevation8: {
            boxShadow: "0px 12px 24px 0px rgba(43, 43, 43, 0.08)",
        },
    },
};
